import React, { useState } from 'react';
import DashboardCalendarPresenter from './DashboardCalendarPresenter';
import DTODashboardCalendar from './DTODashboardCalendar';

interface reporterState {
  cardSize: {
    card_title: string;
  };
}
function DashboardCalendarController() {
  const [cardSize] = useState<reporterState['cardSize']>({
    card_title: '',
  });

  return (
    <>
      <DTODashboardCalendar />
      <DashboardCalendarPresenter cardSize={cardSize} />
    </>
  );
}

export default DashboardCalendarController;
